import { urlFor } from '~/utils/sanity';
export default {
  name: 'BackgroundImage',
  props: {
    image: Object
  },
  methods: {
    urlFor
  }
};